import { Checkbox } from 'components/tailwind-ui/Checkbox';
import * as React from 'react';
import { Customer } from 'types/Customer';
import { Reference } from './Reference';
import { Selection } from './types';

interface Props {
  references?: Customer[];
  displayNoneOption: boolean;
  selected: Selection;
  setSelected: (references: Selection) => void;
}

/**
 * Renders a list of references and a an optional display none option
 */
export const References: React.FC<Props> = (props) => {
  const { references, displayNoneOption, selected, setSelected } = props;

  const handleSelect = React.useCallback(
    (reference: Customer | null, checked: boolean) => {
      const code = reference?.code || null;
      if (checked) {
        setSelected([...new Set([...selected, code as string])]);
      } else {
        setSelected(selected.filter((c) => c !== code));
      }
    },
    [setSelected, selected]
  );

  return (
    <div className="flex flex-col max-h-96 overflow-y-auto scrollbar">
      {references && references.length === 0 && (
        <h4 className="font-medium text-red-900 ml-2 py-2">No reference found…</h4>
      )}
      {displayNoneOption && (
        <Checkbox
          id="reference-filter-none"
          onCheck={(c) => handleSelect(null, c)}
          checked={selected.includes(null)}
          className="px-3 py-2 hover:bg-blue-200"
          label={<div className="font-bold text-gray-400">No reference id assigned</div>}
        />
      )}
      {references &&
        references.map((c) => (
          <Reference
            key={c.id}
            reference={c}
            onChange={handleSelect}
            checked={selected.includes(c.code)}
          />
        ))}
    </div>
  );
};
References.displayName = 'Shipments.Components.ReferenceFilter.References';
